export const LANDING_FAQS = [
  {
    question: "How does the free trial work?",
    answer:
      "Pick a monthly plan and add your card to start. Your bank may show a temporary $1 verification, which disappears on its own. You pay $0 for 5 full days, and the monthly price only starts if you stay. Cancel in one click anytime.",
  },
  {
    question: "Do I need to know about sports to use this?",
    answer:
      "Nope! That's the best part. Upside does all the number-crunching for you. It finds bets worth taking and tells you exactly what to do. Many of our most successful users started as complete beginners. If you can place a bet on an app, you can use Upside.",
  },
  {
    question: "What sportsbooks do you support?",
    answer:
      "We scan 30+ sportsbooks including PrizePicks, DraftKings, FanDuel, Underdog, Hard Rock, Fliff, Pick6, Betr, and more. The full list is inside the app, and we're adding new books regularly. Looking for a new sportsbook? Check our bonus offers for deposit matches and free bets.",
  },
  {
    question: "How is this different from other betting tools?",
    answer:
      "We scan more sportsbooks, update faster (under 3 seconds), and include tools no one else has. Our Odds Screen compares lines across every major book in real time. Whale Watch shows you where the biggest bettors are putting their money. Upside is built by winning bettors, not a marketing company.",
  },
  {
    question: "Is sports betting legal in my state?",
    answer:
      "Sports betting is legal in 38+ states. We support books in every legal state. Check your local regulations for specific details.",
  },
];
